import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Chip from '@mui/material/Chip';
import dayjs from 'dayjs';
import { formatTimeAgo } from '../utils';


export const columns = [
  { field: 'VID', headerName: 'Vehicle ID', flex: 0.75, minWidth: 100 },
  {
    field: 'chassis',
    headerName: 'Chassis #',

    flex: 0.75,
    minWidth: 100,
  },
  {
    field: 'battery_pack_id',
    headerName: 'Battery pack(s)',
    flex: 1,
    minWidth: 140,
  },
  {
    field: 'battery_pack_IMEI',
    headerName: 'IMEI',
    flex: 0.5,
    minWidth: 130,
  },
  {
    field: 'volt',
    headerName: 'Volt.',
    headerAlign: 'right',
    align: 'right',
    flex: 0.5,
    minWidth: 50,
    renderCell: (params) => {
      return (
        <span style={{ color: params.value < 45 ? 'red' : 'inherit' }}>
          {params.value}
        </span>
      );
    },
  },
  {
    field: 'model_bms',
    headerName: 'BMS',
    headerAlign: 'right',
    align: 'right',
    flex: 0.5,
    minWidth: 80,
    valueFormatter: (params) => {
      return params.toUpperCase();
    }
  },
  {
    field: 'last_updated',
    headerName: 'Last Updated',
    headerAlign: 'right',
    align: 'right',
    flex: 1,
    minWidth: 80,
    valueFormatter: (params) => {
      return formatTimeAgo(params, false);
    }
  }
];